/** @jsx jsx */
import BackgroundImage from 'gatsby-background-image'
import {jsx} from 'theme-ui'
import Layout from "../layout"
import { useStaticQuery } from "gatsby"
import Button from "../Button/button"
import IconButton from "../Button/IconButton"
import SectionHeading from "../SectionHeading"
import DarkOverlay from "../DarkOverlay/DarkOverlay"
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import "../Navigation/tabs.css"
// Icons
import Dish from "../../icons/tools-kitchen-serving-dome.svg"

const MenuItems1 = [
    {name: "Fresh Chicken Chow Mein", price: 9.75},
    {name: "Beef Chow Mein", price: 9.75},
    {name: "Deluxe Pork Chow Mein", price: 9.75},
    {name: "Shrimp Chow Mein", price: 12.00},
    {name: "Beef Tomato Chow Mein", price: 11.00},
    {name: "Sesame Chicken", price: 10.00},
    {name: "Sweet & Sour Pork", price: 9.75},
    {name: "Happy Family Chow Yuk", price: 13.50},
]

const MenuItems2 = [
    {name: "Beef Tomato Chow Mein", price: 11.00},
    {name: "Sesame Chicken", price: 10.00},
    {name: "Sweet & Sour Pork", price: 9.75},
    {name: "Happy Family Chow Yuk", price: 13.50},
]

const MenuItem = props => (
   <div sx={{
       display: 'flex',
       justifyContent: 'space-between',
       borderBottom: '1px solid rgba(255,255,255,0.1)',
       py: 3
   }}>
       <div>{props.name}</div>
       <div>${props.price.toFixed(2)}</div>
   </div> 
)

const MenuItemList = props => (
    <div sx={{width: ['100%','50%','50%'], px: 4}}>
        {props.listSource.map((item, index) => (
            <MenuItem name={item.name} price={item.price} key={index}></MenuItem>
        ))}
    </div>
)

const MenuContent = props => (
    <div sx={{position: 'relative', mb: 18, width: '100%'}}>
        <Layout>
            <SectionHeading caption="Featured Dishes" variant="light" smallMargin>Our Menu</SectionHeading>
            <Tabs sx={{
                '.react-tabs__tab--selected': {
                    color: 'white',
                    '::after': {
                        bg: 'primaryColor'
                    }
                },
            }}>
                <TabList>
                    <Tab>Featured Meals</Tab>
                    <Tab>Banana</Tab>
                </TabList>

                <TabPanel>
                    <div sx={{
                        display: ['block', 'flex', 'flex'],my: 6
                    }}>
                        <MenuItemList listSource={MenuItems1} />
                        <MenuItemList listSource={MenuItems2} />
                    </div>
                </TabPanel>
                <TabPanel>
                    <div sx={{
                        display: ['block', 'flex', 'flex'],my: 6
                    }}>
                        <MenuItemList listSource={MenuItems2} />
                        <MenuItemList listSource={MenuItems1} />
                    </div>
                </TabPanel>
            </Tabs>
            <a href="https://ehungry.com/"><Button><IconButton><Dish /></IconButton> View the full menu</Button></a>
        </Layout>
    </div>
)

export default function Menu(props) {
    const data = useStaticQuery(graphql`
        query {
            file(sourceInstanceName: {eq: "backgrounds"}, name: {eq: "menu"}) {
                childImageSharp {
                 fluid(quality:90, maxWidth:2560) {
                    ...GatsbyImageSharpFluid_withWebp
                 }
                }
            }
        }      
    `)
    const imageData = data.file.childImageSharp.fluid

    return(
        <BackgroundImage
        Tag="section"
        fluid={imageData}
        backgroundColor={`#040e18`}
        id={props.id}
        sx={{
            minHeight: '20rem',
            pt: '5rem',
            color: 'white',
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',            
        }}
        >   
            <DarkOverlay raggedTop={props.raggedTop} raggedBottom={props.raggedBottom} raggedTopColor={props.raggedTopColor} raggedBottomColor={props.raggedTopColor} />
            <MenuContent />
        </BackgroundImage>
    )
}